<template>
  <div class="tf-add container">
    <nav class="tf-add__head">
      <Logo />
    </nav>
    <div class="tf-add__data">
      <AddStepper :step="step" />

      <form
        v-if="step === 1"
        class="tf-add__form"
        @submit.prevent="getSummonerData"
      >
        <div class="tf-add__form-field">
          <label
            class="tf-add__form-label"
            for="server"
          >
            Region:
          </label>

          <select
            v-model="server"
            class="tf-add__form-input"
            id="server"
            required
            @change="errorMessage = ''"
          >
            <option value selected disabled>Select region</option>
            <option
              v-for="server of servers"
              :key="server.value"
              :value="server.value"
            >{{ server.name }}</option>
          </select>
        </div>

        <div class="tf-add__form-field">
          <label
            class="tf-add__form-label"
            for="summoner-name">Summoner name:</label>
          <input
            v-model="name"
            class="tf-add__form-input"
            type="text"
            id="summoner-name"
            required
            @input="errorMessage = ''"
          >
        </div>

        <div
          v-if="errorMessage"
          class="tf-add__form-error"
        >
          {{ errorMessage }}
        </div>

        <div class="tf-add__form-buttons">
          <button
            :disabled="loading"
            class="tf-button"
          >
            Next
          </button>
  
          <router-link to="/" class="tf-button tf-button--secondary">
            Back
          </router-link>
        </div>
      </form>

      <form
        v-if="step === 2"
        class="tf-add__form"
        @submit.prevent="verifySummoner"
      >
        <img
          class="tf-add__verify-image"
          src="@/assets/images/verify.gif"
          alt="verification visual"
        >
        <p>
          <b>How to verify your account:</b>
        </p>
        <ol>
          <li>Log into the game</li>
          <li>Go to settings</li>
          <li>From settings go to verification</li>
          <li>Enter the following verification code</li>
        </ol>

        <h2 class="tf-add__code">
          {{ verificationCode }}
        </h2>

        <ol start="5">
          <li>Click save</li>
          <li>Wait for a few seconds then click the verify button below</li>
        </ol>

        <div
          v-if="verifyErrorMessage"
          class="tf-add__form-error"
        >
          {{ verifyErrorMessage }}
        </div>

        <div class="tf-add__form-buttons">
          <button
            :disabled="loading"
            class="tf-button"
          >
            Verify
          </button>
  
          <button
            type="button"
            class="tf-button tf-button--secondary"
            @click="backToStepOne"
          >
            Back
          </button>
        </div>
      </form>

      <form
        v-if="step === 3"
        class="tf-add__form"
        @submit.prevent="finalizeSummoner"
      >
        
        <p class="tf-add__legend">
          🎉🎉🎉<br>
          Welcome! now add your country and a location.
        </p>

        <div class="tf-add__form-field">
          <label
            class="tf-add__form-label"
            for="country"
          >
            Country:
          </label>

          <select
            id="country"
            v-model="country"
            class="tf-add__form-input"
            required
            @change="setCities"
          >
            <option
              v-for="country of countries"
              :key="country.code"
              :value="country.code"
            >
              {{ country.name }}
            </option>
          </select>
        </div>

        <div class="tf-add__form-field">
          <label
            class="tf-add__form-label"
            for="location"
          >
            Region:
          </label>

          <select
            id="location"
            v-model="city"
            class="tf-add__form-input"
            required
            @change="setAreas"
          >
            <option
              v-for="city of cities"
              :key="city"
              :value="city"
            >
              {{ city }}
            </option>
          </select>
        </div>

        <div
          v-if="areas.length"
          class="tf-add__form-field"
        >
          <label
            class="tf-add__form-label"
            for="area"
          >
            City or town (optional):
          </label>

          <select
            id="area"
            v-model="area"
            class="tf-add__form-input"
          >
            <option value="">Not selected</option>
            <option
              v-for="area of areas"
              :key="area"
              :value="area"
            >
              {{ area }}
            </option>
          </select>
        </div>

        <div class="tf-add__form-field">
          <label
            class="tf-add__form-label"
            for="about"
          >
            Write something about yourself (optional):
          </label>

          <input
            id="about"
            v-model="about"
            class="tf-add__form-input"
            maxlength="150"
          >
        </div>
        <ul class="tf-add__about notes">
          <li>- You can promote your stream or Youtube channel</li>
          <li>- Posting any inappropriate content will result in getting your summoner permanently removed from the site</li>
        </ul>

        <div
          v-if="dataErrorMessage"
          class="tf-add__form-error"
        >
          {{ dataErrorMessage }}
        </div>

        <div class="tf-add__form-buttons">
          <button
            :disabled="loading"
            class="tf-button"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { db } from '@/main'
import AddStepper from '@/components/AddStepper.vue'
import Logo from '@/components/Logo.vue'
import axios from 'axios'
import router from '@/router/index'
import { servers, cloudFunctionBaseUrl } from '../constants'

export default {
  name: 'Add',

  components: {
    AddStepper,
    Logo
  },

  data() {
    return {
      errorMessage: '',
      verifyErrorMessage: '',
      dataErrorMessage: '',
      loading: false,
      name: '',
      server: '',
      city: '',
      area: '',
      country: '',
      twitch: '',
      facebook: '',
      youtube: '',
      about: '',
      countries: [],
      cities: [],
      areas: [],
      step: 1,
      summonerData: {},
      cityTimeout: undefined,
      verificationCode: `townfaker${Math.round(Math.random() * 1000)}`,
      servers
    }
  },

  async created() {
    const countriesRef = await db.collection('countries').doc('countries').get()
    const countryList = countriesRef.data()
    this.countries = countryList.countries
  },

  methods: {
    async getSummonerData() {
      if (this.loading) {
        return
      }

      this.errorMessage = ''
      this.loading = true

      try {
        const response = await axios.get(`${cloudFunctionBaseUrl}getSummonerId?name=${this.name}&server=${this.server}`)
        this.summonerData = response.data.summoner
        this.step = 2
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.errorMessage = error.response.data.message
        } else {
          this.errorMessage = 'Error fetching summoner data, please try again later.'
        }
      } finally {
        this.loading = false
      }
    },

    async verifySummoner() {
      if (this.loading) {
        return
      }
      this.verifyErrorMessage = ''

      this.loading = true

      try {
        const response = await axios.get(`${cloudFunctionBaseUrl}verifySummoner?id=${this.summonerData.id}&server=${this.server}`)

        if (this.verificationCode === response.data.clientCode) {
          this.step = 3
        } else {
          this.verifyErrorMessage = `Invalid code detected [${response.data.clientCode}], please enter ${this.verificationCode} in the game client, if you're sure that you've entered the right code restart your game client and try again`
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.verifyErrorMessage = error.response.data.message
        } else {
          this.verifyErrorMessage = 'No code detected, please restart your league client and try again'
        }
      } finally {
        this.loading = false
      }

    },

    async finalizeSummoner() {
      if (this.loading) {
        return
      }

      this.loading = true

      const existingCity = this.cities.includes(this.city)

      if (!existingCity) {
        return
      }
      const countryName = this.countries.find(country => country.code === this.country).name

      try {
        let path = `${cloudFunctionBaseUrl}finalizeSummoner?`
        path += `id=${this.summonerData.id}`
        path += `&server=${this.server}`
        path += `&city=${this.city}`
        path += `&area=${this.area}`
        path += `&country=${countryName}`
        path += `&code=${this.verificationCode}`
        path += `&about=${encodeURIComponent(this.about)}`

        const response = await axios.get(path)

        router.push({ name: 'home', query: { country: countryName,  region: this.city} })
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.verifyErrorMessage = error.response.data.message
        } else {
          this.verifyErrorMessage = 'Unable to save summoner data, please try again later'
        }
        
      } finally {
        this.loading = false
      }
    },

    backToStepOne() {
      this.verifyErrorMessage = ''
      this.step = 1;
    },

    async setCities() {
      this.city = ''
      this.area = ''
      this.areas = []
      const citiesRef = await db.collection('cities').doc(this.country).get()
      const country = citiesRef.data()
      this.cities = country.cities
    },

    async setAreas() {
      this.area = ''
      this.areas = []
      if (this.city) {
        const areasRef = await db.collection('areas').doc(this.city).get()
        if (areasRef.empty) {
          this.areas = []
        } else {
          const areasSnap = areasRef.data()
          this.areas = areasSnap.areas
        }
      } else {
        this.areas = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tf-add {
  &__head {
    padding: 10px 0;
  }

  &__data {
    max-width: 600px;
    border-radius: 3px;
    margin: 10vh auto 0;
    border: 1px solid #ddd;
    background-color: #fff;
  }

  &__form {
    padding: 20px;
  }

  &__form-field {
    margin-bottom: 15px;
  }

  &__disclaimer {
    padding: 0 20px 10px;
    font-size: 14px;
    color: #555;
    text-align: center;
  }

  &__form-label {
    display: block;
    margin-bottom: 4px;
  }

  &__form-input {
    width: 100%;
    font-size: 16px;
    padding: 0 8px;
    height: 40px;
  }

  &__form-error {
    color: #721c24;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 10px;
  }

  &__form-buttons {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding-top: 5px;
  }

  &__code {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
    font-family: var(--head-font);
  }

  &__verify-image {
    width: 100%;
    margin-bottom: 15px;
  }

  &__legend {
    font-size: 18px;
    max-width: 320px;
    margin: 15px auto 25px;
    text-align: center;
    font-family: var(--head-font);
  }

  &__confetti {
    display: block;
    margin: 10px auto;
    transform: translateX(5px);
  }
}
</style>